import { useState } from "react";
import api from "../api";
import { Button, TextField, Box, Typography, Alert } from "@mui/material";
import handleApiError from "../utils/handleApiError";

export default function AdminLogin({ onLogin }) {
  const [data, setData] = useState({ username: "", password: "" });

  const [error, setError] = useState("");
  const login = async () => {
    try {
      const res = await api.post("/auth/login", data);
      localStorage.setItem("token", res.data.token);
      onLogin();
    } catch (err) {
      setError(handleApiError(err));
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f4f6f8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ maxWidth: 400, mx: "auto" }}>
        <Typography variant="h5">Admin Login</Typography>
        {error && <Alert severity="error">{error}</Alert>}

        <TextField fullWidth margin="normal" label="Username" onChange={(e) => setData({ ...data, username: e.target.value })} />
        <TextField fullWidth margin="normal" label="Password" type="password" onChange={(e) => setData({ ...data, password: e.target.value })} />

        <Button fullWidth variant="contained" onClick={login}>
          Login
        </Button>
      </Box>
    </Box>
  );
}
